import React from "react";
import Services from "../sections/Services.jsx";
export default function PageServices() { return <Services />; }
